module.exports = __webpack_public_path__ + "img/head-not-start-cover.a0d964c2.jpg";